import {PosOrderSummary} from "@/data/entities/order";
import {FulfillmentFilter} from "@widgets/pos/orders/sidebar/fulfillment/fulfillmentFilterButtons";

export const normalize = (value: string): string =>
    value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // é -> e, ı stays
        .toLowerCase();

/**
 * Digits only, without leading 0 or 31 country code, so "06 1234" matches
 * "+31 6 12345678".
 */
const phoneDigits = (value: string): string =>
    value.replace(/\D/g, "").replace(/^(0031|31|0)/, "");

export const matchesSearch = (order: PosOrderSummary, terms: string[]): boolean => {
    const text = normalize([
        order.firstName,
        order.lastName,
        order.account,
        order.street,
        order.streetNumber,
        order.city,
        order.cartId,
    ].filter(v => v !== null && v !== undefined).join(" "));
    const phone = phoneDigits(order.phoneNumber);

    return terms.every(term => {
        if (text.includes(term))
            return true;

        // Phone: only for terms that are (mostly) digits, at least 3 of them
        const digits = phoneDigits(term);
        return digits.length >= 3 && /^[\d\s()+\-.]+$/.test(term) && phone.includes(digits);
    });
};

type FilterOrdersArgs = {
    orders: PosOrderSummary[],
    fulfillmentFilter: FulfillmentFilter,
    searchQuery: string,
};

export const filterOrders = ({orders, searchQuery, fulfillmentFilter}: FilterOrdersArgs) => {
    const terms: string[] = normalize(searchQuery).split(/\s+/).filter(t => t.length > 0);

    return orders.filter((order: PosOrderSummary) => {
        // Filter out on fulfillment
        if (fulfillmentFilter === "TAKEAWAY" && order.delivery)
            return false;

        if (fulfillmentFilter === "DELIVERY" && !order.delivery)
            return false;

        // Match search
        return terms.length === 0 || matchesSearch(order, terms);
    });
};
